const ja = {    // 日语
    message: {
        noNet: 'ネットワークエラー',
        goCopilot: 'その夜の睡眠の分析と提案',
        goCopilotWeek: '今週の睡眠を分析する',
        goCopilotMonth: '今月の睡眠を分析する',
        updateAppTips: '現在のバージョンは表示できません。最新バージョンにアップデートしてください！',
        vip: {
            openVip: "会員登録解除",
            sleepVip: "スリープメンバーシップ",
            notOpened: "まだ加入していない",
            expired: "期限切れ",
            validUntil: "有効期限: ",
            unlockAll: "すべての睡眠補助音楽のロックを解除",
            trendAnalysis: "睡眠トレンド分析",
            reportAnalysis: "パーソナライズされた月次レポート分析",
            deepAnalysis: "詳細な睡眠分析",
            monthlyVip: "毎月",
            quarterlyVip: "四半期ごと",
            annualVip: "年間",
            priceEvery: "{yuan}{price} 1ヶ月あたり",
            yuanEveryMonth: "",
            yuanEveryQuarter: "",
            yuanEveryYear: "",
            open: "加入する",
            renew: "今すぐ更新",
            renewal: "更新",
            vipMonthExtention: "",
            vipQuartyExtention: "",
            vipYearExtention: "",
            discountLimited: "期間限定{discount}割引",
            discountDuration: "{date}までの期間限定キャンペーン",
            vipUseDescription1: '睡眠導入音楽をすべてアンロック',
            vipUseDescription2: '就寝時刻、起床時刻のトレンド',
            vipUseDescription3: '心拍数、血中酸素のトレンド',
        },
        sleep: {
            regularSleep: "通常の睡眠",
            nap: "昼寝",
            hour: "時間",
            minute: "分",
            sleepQuality: "睡眠の質",
            sober: "目が覚める",
            fastEye: "REM",
            lightSleep: "浅い眠り",
            darkSleep: "深い眠り",
            sleepStage: "睡眠段階",
            suggestRange: "おすすめ",
            avgSleepHeartRate: "平均睡眠時心拍数",
            timesEveryMin: "拍/分",
            unitsleepbreath: "brpm",
            once: "拍",
            sleepOxygen: "睡眠中の血中酸素",
            sleepBreath: "睡眠時呼吸数",
            highest: "最大",
            lowest: "最小",
            maximum: "最大",
            minimum: "最小",
            normal: "正常",
            average: "平均",
            openMonitoring:  "監視をオンにした回数",
            longerMonitor: "モニタリングの日数が長いほど、より精度が高い",
            avgStatistics: "平均データ",
            sleepDuration: "睡眠時間",
            bedTime: "就寝時間",
            getUpTime: "起床時間",
            maxSleep: "最長睡眠時間",
            minSleep: "最短睡眠時間",
            earliestBedTime: "最も早い就寝時間",
            latestBedTime: "最遅の就寝時間",
            earliestGetUpTime: "最も早く起きる時間",
            latestGetUpTime: "最新の起床時間",
            excellent: "優秀",
            good: "良い",
            improvement: "改善する必要がある",
            importance: "要注意",
            sleepEnough: "適切な: {min}-{max}時間",
            sleepToLong: "過度な睡眠：{hour}時間以上",
            sleepDebt: "睡眠不足：{hour}時間未満",
            sleepPeriodVary1: "睡眠時間は年齢によって異なります、現在記入されている年齢は{age}歳です",
            sleepPeriodVary2: "睡眠時間は年齢によって異なります。現在の年齢は{month}月です",
            toSet: "設定",
            openVipToSee: "継続するために会員にアップグレードする",
            short_mon: "月",
            short_tue: "火",
            short_wed: "木",
            short_thu: "水",
            short_fri: "金",
            short_sat: "土",
            short_sun: "日",
            mon: "月曜",
            tue: "火曜",
            wed: "木曜",
            thu: "水曜",
            fri: "金曜",
            sat: "土曜",
            sun: "日曜",
            monday: "月曜",
            tuesday: "火曜",
            wednesday: "木曜",
            thursday: "水曜",
            friday: "金曜",
            saturday: "土曜",
            sunday: "日曜",
            day: "",
            heartRate: "心拍数",
            bloodOxygen: "血液中の酸素飽和度",
            breathRate: "呼吸数",
            noData: "通常の睡眠データはありません",
            noNapData: "昼寝記録なし",



            sleepLateTipCommonStart: "あなたは昨夜予定されていた就寝時間より遅く寝た。",
            sleepTipCommonEnd: "規則正しい睡眠時間を守ることは、睡眠の健康にとって良いことです。",
            sleepLate3tip: "今週はいつもより遅くまで寝ていましたね。これは今週 {day} 日起こりました。日常に関係なく、睡眠に気をつけてください。",
            sleepLate2TipStart: "あなたは昨夜予定されていた就寝時間より遅く寝た。",
            sleepLate2Tip: "今週はいつもより遅くまで寝ていましたね。2日連続ですね。十分な睡眠をとるように心がけてください。",
            getUpEarlyTip: "あなたは今日、予定されていた起床時間より早く起きた。",
            getUpLateTip: "あなたは今日、予定された起床時間よりも遅く起きました。",
            sleepEarlyTip: "あなたは昨夜、予定されていた就寝時間よりも早く寝ました。",


            demoData: "デモデータ",

            sleepCompare: "睡眠データ比較",
            seeMore: "もっと見る",
            sleepQualityData: "あなたの睡眠の質は{value}で",
            sleepQualityCompare1: "を上回っています",
            sleepQualityCompare2: "仅高于", // todo！！！
            sleepQualityCompare3: "を上回っています",
            sleepQualityBestTip: "質の良い睡眠を取り続けることで、スリープヘルスが確保できますよ～",
            sleepQualityGoodTip: "睡眠の質を改善する必要がありますよ！",
            sleepQualityBadTip: "質の良い睡眠を取るように心掛けてください",
            sleepTimeText: "睡眠時間",
            avgCnSleepTimeText: "中国平均睡眠时长", // todo
            avgGlobalSleepTime: "グローバル平均睡眠時間",
            sleepTimeTip: "誰もが十分な睡眠時間を確保する必要があります。これは効果的に疲労感を解消し、体の健康にもある程度メリットがありますが、睡眠時間が長すぎないように心がけてください。",
            bedTimeText: "就寝時間",
            avgCnBedTimeText: "中国平均就寝时间", // todo
            avgGlobalBedTime: "グローバル平均就寝時刻",
            bedTimeTip: "就寝時刻は簡単そうに見えますが、実は重要な指標です。良い就寝習慣を身に付けることで脳の健康が守られ、眠りやすくなり、睡眠の質も向上できます。",
            getUpTimeText: "起床時間",
            avgCnGetUpTimeText: "中国平均起床时间", // todo
            avgGlobalGetUpTime: "グローバル平均起床時刻",
            getUpTimeTip: "起床時刻も見過ごすのできない指標であり、規則正しい起床時刻を保証することで、一日中良い精神状態を保つことができます。",

            sleepStageTitle: "睡眠段階分析",
            avgAwakeSleep: "平均起きている",
            avgFastEyeMove: "平均レム",
            avgShallowSleep: "平均浅い眠り",
            avgDeepSleep: "平均深い眠り",
            skinTemperature: "皮膚温度",
            temperatureLow: "低価値の割合",
            temperatureHigh: "高数値の割合",
            reasonableRange: "適正範囲",
            compare: {
                dataInsights: 'データインサイト',
                today: '今日',
                yesterday: '昨日',
                currentWeek: '今週',
                preWeek: '先週',
                currentMonth: '今月',
                preMonth: '先月',
                daySleepTimeHigher: '今日の睡眠時間は昨日より長いです。',
                daySleepTimerLower: '今日の睡眠時間は昨日より短いです。',
                daySleepTimerRegular: 'ここ最近2日間の睡眠時間は比較的規則的です。',

                dayBedTimeEarly: '今日の就寝時間は昨日より早いです。',
                dayBedTimeLater: '今日の就寝時間は昨日より遅いです。',
                dayBedTimeRegular: 'ここ２日間の就寝時間は比較的規則的です。',

                dayGetupTimeEarly: '今日の起床時間は昨日より早かったです。',
                dayGetupTimeLater: '今日の起床時間は昨日より遅れました。',
                dayGetupTimeRegular: 'この２日間、起床時間は比較的規則的でした。',
                DayEmptyTip: '昨日は睡眠履歴がありませんが、装置を睡眠中に付けたままにすると、睡眠データを把握することができます。',


                weekSleepTimeHigher: '今週の平均睡眠時間は先週よりも長いです。',
                weekSleepTimerLower: '今週の平均睡眠時間は先週よりも短いです。',
                weekSleepTimerRegular: 'ここ２週間の平均睡眠時間は比較的安定しています。',

                weekBedTimeEarly: '今週の平均就寝時間は先週よりも早いです。',
                weekBedTimeLater: '今週の平均就寝時間は先週よりも遅いです。',
                weekBedTimeRegular: 'ここ２週間の平均就寝時間は比較的安定しています。',

                weekGetupTimeEarly: '今週の平均起床時間は先週よりも早いです。',
                weekGetupTimeLater: '今週の平均起床時間は先週よりも遅いです。',
                weekGetupTimeRegular: 'ここ2週間の平均起床時間は比較的規則的でした。',
                weekEmptyTip: '先週は睡眠データがなかったので、睡眠時に装置を着用することで睡眠データを把握できます。',


                monthSleepTimeHigher: '今月の平均睡眠時間は先月より長いです。',
                monthSleepTimerLower: '今月の平均睡眠時間は先月より短いです。',
                monthSleepTimerRegular: 'ここ最近2か月の平均睡眠時間は比較的規則的です。',

                monthBedTimeEarly: '今月の平均就寝時間は先月より早いです。',
                monthBedTimeLater: '今月の平均就寝時間は先月より遅いです。',
                monthBedTimeRegular: '最近2ヶ月の平均就寝時間は比較的規則的です。',

                monthGetupTimeEarly: '今月の平均起床時間は先月より早いです。',
                monthGetupTimeLater: '今月の平均起床時間は先月より遅いです。',
                monthGetupTimeRegular: '最近2ヶ月の平均起床時間は比較的規則的です。',
                monthEmptyTip: '先月は睡眠データが記録されていませんでした。睡眠トラッキングデバイスを睡眠時に着用することで、睡眠データを把握できます。',

                delete: '削除する',
                deleteTitle: '日報の記録を削除しますか？',
                deleteContent: '日報の記録を削除した場合、対応する週報と月報のデータも削除されます。現在の日報のデータを永久に削除してもよろしいですか？',
                confirm: '確定',
                cancel: 'キャンセル'

            }
        },
        advert: {
            tip: '早期割引',
            ActivityEndTime: '終了時間',
            ActivityStartTime: '開始時間',
            ActivityEnded: 'ended～',
            buy: 'すぐに購入',
            explainTitle: 'イベント説明：',
            explainDesc1: '1.早期割引イベントの継続時間は2022.12.16～2022.12.31',
            explainDesc2: '2.期間中は、会員の権利を最低価格5.5割引で購入できる',
            explainDesc3: '3.チャージ成功後、「トップページ-睡眠カード-睡眠開始-vip」で会員特権の有効期間を確認できる',
            explainDescLast: '4.イベントの最終解釈権はmobvoiを所属する',
            viewVipFunctions: '会員機能を確認する',
            VipFunctionsExplain: "会員機能を確認する"
        },
        snore: {
            "snoringDetectionReport": "いびき検査レポート",
            "snoreRecord": "いびき記録",
            "more": "もっと見る",
            "notOpenedTip": "就寝前に、「ホーム-睡眠カード-睡眠を始める-即座に就寝」でいびき監視機能をオンにしてください。睡眠が終わったら、監視をオフにすることを忘れずに、いびきの記録が自動的に生成されます。",
            "noSnoring": "今回の睡眠でいびきなし〜",
            "snoreData": "イビキ音データ",
            "snoreReport": "いびき報告書",
            "snoreDuration": "期間",
            "avgSnoreDb": "平均デシベル",
            "maxSnoreDb": "最大デシベル",
            "minSnoreDb": "最小デシベル",
            "snoreDbRatio": "いびきの分贝比率",
            "snoreWaveforms": "いびき波動傾向",
            "snoreFrequency": "いびきの頻度分布",
            "snoreFrequencyTrend": "いびき頻度トレンド",
            "low": "低周波",
            "medium": "中周波",
            "high": "高周波",
            "softSnore": "軟口蓋いびき",
            "uvulaSnore": "会厭いびき",
            "tongueSnore": "舌根いびき",
            "snoreRecordSetting": "設定",
            "storageMethods": "保存方法",
            "storageDurations": "保存時間",
            "local": "ローカル",
            "cloud": "クラウド",
            "localStorage": "ローカルストレージ",
            "cloudStorage": "クラウドストレージ",
            "storageWayTips": "鼾声データをローカルまたはクラウドに保存することができます。ローカル保存ではストレージを使用します。クラウド保存には睡眠会員の権限が必要で、最大で180日間のデータを保持することができます。",
            "storagePeriod": "いびきデータの保存期間を選択できます。データの安全性を確保するために、最短1日、最長180日の保存期間を設定しています。1日を選択した場合、翌日にいびきデータが削除されます。会員登録後は30日と180日の保存期間がご利用いただけます。",
            "storagePeriodWearCopilot": "いびきデータの保存期間を選択できます。",
            "day": "日",
            "days": "日",
            recordSnoreTitle1: '1.いびきを記録する',
            recordSnoreContent1: '毎晩寝る前にいびき検出機能をONにし、起床後に睡眠を手動で終了し、完全ないびきデータを記録してください',
            recordSnoreTitle2: '2.日報でいびき記録を確認する',
            recordSnoreContent2: '日報には3つのいびき記録が表示され、クリックすると自分のいびき記録を再生できます。',
            recordSnoreTitle3: '3.より多くのいびきデータ分析',
            recordSnoreContent3: 'デイリーレポートで「もっと見る」をクリックして、すべての鼾の記録を表示し、音量、波形、分布、周波数などを分析することができます。',
            "tips": "ヒント",
            "vipTips": "この機能を有効にするには、睡眠メンバーシップを開始する必要があります。いますぐ睡眠メンバーシップを開始しますか？",
            "open": "今すぐ開通",
            "noAudioTip": "いびき音声の読み込み中です。しばらくお待ちください。",
        },
    },

    "cookie_policy": {
        "title": "Cookieポリシー",
        "para": "当社はクッキー、ログファイル、ウェブビーコン、スクリプト、タグ、及び他の追跡技術を時々利用して、お客様に関する情報を収集し、使用し、保存することがあります。このパートでは、このような追跡技術の使用方法について説明します。",
        "q_1": {
            "question": "1. 当社が追跡技術を利用する原因は何ですか？",
            "ans_1": "A. Mobvoiサービスをよりよく理解し、それをお客様とユーザーに提供することに役立ちます。",
            "ans_2": [
                "B. 追跡技術により、我々はお客様を理解し、よりよいMobvoiサービスを提供することができます。たとえば、我々にとって追跡サービスは以下の情報を集めるのに役立ちます。",
                "a) 我々がMobvoiサービスを提供する際に、お客様が情報を確認することが必要です。",
                "b) 地図とロケーションベースのサービスでは、お客様の現在地情報が必要です。",
                "c) 翻訳サービスでは、お客様の言語設定に関する情報が必要な場合があります。",
                "d) Mobvoiサービスを提供するとともに新しい機能を開発することができるように、当社はユーザーの他の関連情報を必要とします。"
            ]
        },
        "q_2": {
            "question": "2. 追跡技術とは",
            "para": "Mobvoiの中で使用されている「追跡技術」は以下の内容を含んでいます。",
            "ans_1": "A. クッキーとは、一連の単語を含む小さなファイルで、ウェブサイトや他のウェブコンテンツにログインする際に、コンピュータ、携帯電話、またはその他のデバイスに保存されます。",
            "ans_2": "B. ウェブビーコンとは、ウェブサイトや電子メールにインストールされた電子画像ファイルまたは他の技術であり、コンピュータ訪問者の数をカウントし、電子メールまたはウェブサイトを見たかどうかを記録したり、それらを見た時間を記録したりすることができます。",
            "ans_3": "C. ログファイルには、自動的に収集される情報がいくつか保存されます。その中にIPアドレス、ブラウザ種類、ISP、参照/終了ページ、オペレーションシステム、日付/タイムスタンプおよびクリックストリームデータが含まれます。",
            "ans_4": "D. ETタグとは、インターネットブラウザとインターネットサーバの間で転送されるHTTPプロトコルのヘッダであります。クッキーの代わりに一人一人のユーザーを追跡し、当社がそれによってMobvoiサービスを理解し、改善することができます。",
            "ans_5": "E. JavaScriptはプログラミング言語の一種であり、インタラクティブでダイナミックなページを作成するために使用されます。JavaScriptはクッキーの設定、読み取り、削除を行うことができます。"
        },
        "q_3": {
            "question": "3. 追跡技術の使い方",
            "para": "当社は第三者とパートナーシップを結び、追跡技術を使用します",
            "ans_1": "A. 追跡技術を通して、当社や関連会社および第三者パートナーは情報を収集し、使用することができます。",
            "ans_2": "B. 当社の分析パートナーは、お客様がMobvoiについて全体的で深い理解を得るのに役立ちます。例えば、ウェブサイトやアプリフォームの使用データやユーザーの基本的な人口統計情報を収集し、関連する傾向を分析します。",
            "ans_3": "C. 当社のお客様サポートサービスパートナーは、お客様のお問い合わせを的確に対応し、ユーザーにMobvoiのより良い使用経験を提供することを支援します。",
            "ans_4": "D. 当社のサービスパートナーは、ウェブキャッシュ、言語翻訳、地図サービスなどといったMobvoiサービス機能の管理と提供を支えます。",
            "ans_5": "E. 当社は、このような追跡技術を利用して、パートナーからの個人的および全体的なユーザーに関する報告書を入手することができます。"
        },
        "q_4": {
            "question": "4. 当社の追跡技術",
            "ans_1": "A. さらに、当社は追跡技術を利用して、より良いパーソナライズされたサービス体験を実現します。たとえば、お客様の好みを把握し、音声アシスタントの対話履歴を使って質問に正確に答えます。旅行手配の情報を利用して、旅行のヒントをお客様に提供します。スポーツ及び健康情報を利用してスポーツ及び健康提案を提供します。ウォッチダイヤルマーケットとアプリストアで購入情報を分析して、関心のあるダイヤルプレートとアプリを推薦します。",
            "ans_2": "B. お客様の身元情報を記録します。たとえば、クッキーやウェブビーコンは、サービス登録ユーザーであることを認識したり、以前に提供した設定やその他の情報を保存したり、サービスの使用方法を分析するのに役立ちます。当社は追跡技術を利用して、ユーザーが当社のサービスで行った活動やページやリンクの人気を理解することができます。",
            "ans_3": "C. そのような目的に達するのために、追跡技術を使用していますが、お客様と他のユーザーが当社のサービスをどのように使用しているかを分析するために、追跡技術によって収集された非個人的な情報を他のパートナーに提供することもできます。"
        },
        "q_5": {
            "question": "5. 追跡技術に関する一般条項",
            "ans_1": "A. 第三者による追跡技術は、当社のプライバシーポリシーではなく、第三者のプライバシーポリシーに拘束されていることに注意する必要があります。当社は、第三者の追跡技術に関しての責任を負いません。",
            "ans_2": "B. 我々は、追跡技術によって収集された情報を、収集された他の情報と組み合わせることができます。たとえば、第三者のオンライン広告を通じて、Mobvoiサービスをインストールして登録する場合、当社および/または第三者のパートナーは追跡技術を利用して、お客様がどちらでMobvoiサービスを知っているのか分かります。"
        },
        "q_6": {
            "question": "6. どのように追跡技術をコントロールできますか？",
            "ans_1": "A. ブラウザの設定（クッキーやウェブビーコンなど）やモバイルデバイスを変更して、一部のカテゴリの追跡技術を禁止または管理することができます。ただし、追跡技術の使用が禁止されると、Mobvoiサービスの使用経験を最大限に活用できず、Mobvoiの一部または全部の機能が正常に動作しない可能性があります。",
            "ans_2": "B. Mobvoiのサービスの設定で、追跡技術によって収集できる情報をコントローできます。"
        }
    },
    "terms_of_service": {
        "title": "利用規約",
        "para_1": [
            "以下の利用規約は、Mobvoi Information Technology Company Limitedおよびその関連会社（以下「Mobvoi」または「当社」）が発行するすべてのアプリに適用されます。www.chumenwenwen.com、store.ticwear.com、www.mobvoi.com（ワイヤレスデバイスやタブレットデバイスでの視聴に最適化されたバージョンを含む）などのMobvoiウェブサイトや、Mobvoiが発行するまたは配布するすべての電子メールニュースレターや、Mobvoiによってアクセスおよび/または利用され、運営され、利用可能になり、またはMobvoi（以下「アプリ」と総称します）によって作成され、確保され、どのような方法でもアクセスおよび/または使用されるその他のすべての対話型機能および通信機能とMobvoiが提供するすべてのサービスは、アプリを介して、またはアプリと関連して提供するものです（以下「本サービス」と略称します）。当社のアプリを使用することで、お客様はこれらのサービス条件で説明されているプラクティスを受け入れています。これらの利用規約に同意しない場合は、アプリを使用せずにすぐに終了してください。当社は、これらの利用規約を時々変更または修正する権利を留保します。これらの条件の変更を掲載した後に引き続きアプリを使用すると、それらの変更を受け入れることになります。特定の通知をお客様に提供しない限り、当社の利用規約の変更は遡及して適用されません。サービスの一部については、サブスクリプション契約を締結する必要があります。"
        ],
        "para_2": "これは、お客様（「お客様」または「ユーザー」）とMobvoiとの間の合法的な合意であり、お客様がアプリを使用することに適用される重要な条件を述べています。この契約は、すべてのアップデート、補足、追加条件、およびMobvoiのすべてのルールとポリシーとともに、お客様とMobvoiとの間のこの「契約」を構成します。アプリにアクセスすることにより、本契約に法的拘束されることに同意したことになります。ここに記載されている利用規約と使用条件に同意しない場合は、アプリを使用せず、端末からアプリを削除してください。",
        "terms_1": [
            "1. アプリとウェブサイトアクセスライセンス",
            "。 Mobvoiは、お客様にアプリまたはそのコンテンツにアクセスして使用するための、限定的で取り消し可能で非独占的かつ譲渡不能なライセンスを付与します。このライセンスには、アプリまたはそのコンテンツの再販または商用利用、製品リスト、説明、または価格の収集および使用、アプリまたはその内容の派生使用、他の販売者の利益のためのアカウント情報のダウンロードまたはコピー、データマイニング、ロボット、または同様のデータ収集および抽出ツールの使用は含まれません。Mobvoiの明示的な書面による同意なく、アプリおよび/またはアプリの一部を商業目的で複製、販売、転売、訪問、その他の方法で利用することはできません。明示的な書面による同意なく、当社の名前または商標を使用するメタタグまたはその他の「隠しテキスト」を使用することはありません。さらに、お客様は、（i）当社の裁量でインフラストラクチャーに不当な、または不釣り合いで大きな負荷を課す、または課す可能性がある措置を取ること、（ii）本アプリの適切な作業または本アプリの一部として実施されるすべての行為を妨害または妨害しようとすること、（iii）アプリへのアクセスを防止または制限するために使用する可能性のある措置を迂回することをしないべきです。許可されていない使用は、私たちがお客様に与えた許可および/またはライセンスを自動的に終了します。"
        ],
        "terms_2": [
            "2. 著作権と所有権",
            "。アプリに特集された、または表示されたすべてのコンテンツは、Mobvoiまたはそのライセンサ、ベンダ、代理店、および/またはそのコンテンツプロバイダが所有しています。コンテンツは制限テキスト、グラフィックス、写真、画像、動画、音声、イラスト（以下「コンテンツ」といいます）を含んでいますが、これらに限定されないです。アプリのすべての要素は、トレードドレス、著作権、モラル上の権利、商標およびその他の知的財産権に関する法律によって保護されています。要素は一般的なデザインやコンテンツを含んでいますが、これらに限定されないです。当該利用可能になるアプリは、意図された目的にのみ使用することができます。著作権法が許可されている場合を除き、お客様は本書に記載されている資料を変更することはできず、アプリに含まれる情報や作品を複製、配布、送信、表示、実行、再生、出版、ライセンス供与、作品のの派生物を作成、譲渡、販売することはできません。著作権法が許可されている場合を除き、お客様は、アプリで利用可能な著作物を再利用する前に許可を得る責任があります。お客様は、アプリの使用に関する適用される国内法および国際法、法令、規則および規制をすべて遵守しなければなりません。明示的に合意しない限り、アプリ、コンテンツ、および関連するすべての権利は、Mobvoiまたはそのライセンサーの独占的なものとします。お客様は、アプリに記載されている素材から著作権、商標、またはその他の所有権に関する通知を削除しません。"
        ],
        "terms_3": [
            "3. 商標/免責事項",
            "。 本書（Mobvoiの名前、Mobvoiの会社のロゴ、アプリの名前、アプリのデザイン、および任意のロゴを含んでいますが、これに限定されないです。）で使用されているMobvoiのすべての商標、サービスマーク、および商標名（「マーク」と総称します）は、Mobvoiまたはその関連会社、パートナー、ベンダーまたはライセンサーの商標または登録商標です。Mobvoiの事前の書面による同意なく、Mobvoiの商標を何らかの方法で使用、複製、再生、再発行、アップロード、投稿、送信、配布、または変更することはできません。アプリ上の資料の配布に関する広告や宣伝なども含まれます。事前の書面による同意なく、Mobvoiの判断で、お客様は、Mobvoiの名前やMobvoiの裏書を意味する可能性のある言語、画像、または記号を使用してはならないです。いかなる性質であっても、例えば（1）書面または口頭による広告またはプレゼンテーション、（2）パンフレット、ニュースレター、書籍、またはその他の書面による資料で、使用してはいけません。"
        ],
        "terms_4": [
            "4. アカウントの登録とセキュリティ",
            "。 お客様は、アプリのすべての部分にアクセスするように、アカウントを作成する必要があるかもしれないことを理解しなければならないです。これらのアプリの制限された部分を使用するために、お客様は（a）アプリの登録ページまたは購読ページ（「登録データ」）に表示されるように、お客様および個人のビジネスに関する正確で最新の完全な情報を提供すること。（b）登録データを正確で、最新かつ完全に維持するために登録データを管理し、速やかに更新すること。お客様が間違っている、不正確な、現在ではない、または不完全な情報を提供した場合、またはMobvoiはそのような情報が間違っている、不正確な、現在ではないまたは不完全と疑う合理的な理由がある場合、Mobvoiはお客様のアカウントを一時停止または終了し、アプリ（またはその一部）の現在および将来の使用をすべて拒否する権利を有します。お客様は、パスワードとアカウントのセキュリティと秘密保持について全面的に責任を負います。さらに、お客様のアカウントで発生するすべての行為について、お客様は完全に責任を負うものとします。アカウント情報またはユーザー名とパスワードを第三者と共有したり、第三者にアカウント情報を使用してアプリにログオンさせたりすることはありません。お客様は、自分のアカウントの不正使用、またはお客様が認識しているその他のセキュリティ侵害を直ちに当社に通知することに同意するものとします。お客様は、自分の状況やアプリの意図された使用に最も適した予防策を講じ、セキュリティ対策を提供する責任があります。当社は、特定の状況（法的責任、法的手続き、命令、召喚状、またはワラントに応じたり、当社の権利、顧客またはビジネスを保護するためなど）に基づいて、ユーザーの請求、口座、コンテンツまたは使用記録および関連情報を提供する権利を有します）。お客様の個人情報を提供できる人は誰でもお客様のアカウントにアクセスできますので、この情報を保護するための合理的な措置を講じる必要があります。"
        ],
        "terms_5": [
            "5. 請求された投稿ポリシー",
            "。Mobvoiが投稿やコメントを特別に招待したり依頼したりした場合、MobvoiはMobvoiにコンテンツ（例：ブログ投稿へのコメント、コミュニティへの参加、ヒントなど）を提出することをお勧めします（以下",
            "「ユーザー投稿」",
            "といいます）。ユーザー投稿は、個々のユーザーの知的財産です。アプリにコンテンツを投稿することで、お客様は Mobvoi に、使用、複製、改変、適応、出版、翻訳、派生作品の作成、配布、送信、実行、および表示する非独占的かつ永久的で、取消不能で、ロイヤルティフリーで、完全に払い込まれた世界的かつ完全にサブライセンス権利を明示的に付与します。お客様のユーザー投稿に含まれるそのようなコンテンツとお客様の名前、声、および/または類似性を全部または一部に、そして世界中のどのような形で表示するあらゆるメディアや技術において、促進、広告、マーケティング、マーチャンダイジング、宣伝、その他の付随的な使用を含むすべての目的に使用されるものとし、宇宙全体に恒久的にそのような権利を再許諾する自由な権利を含みます。そのようなユーザー投稿は非機密とみなされ、 Mobvoi はユーザー投稿に含まれるいかなる形式のいかなる情報の秘密保持を維持する義務はありません。"
        ],
        "terms_6": [
            "6. 不適切なユーザー投稿",
            "。 Mobvoi は奨励しておらず、以下のような活動から生じたユーザー投稿を求めません。（i）お客様自身、他の人、動物に危害、喪失、身体的または精神的傷害、精神的苦痛、死亡、身体障害、または身体的または精神的病気の危険をもたらす可能性があります。（ii）人物または財産に対するその他の損失または損害のリスクを生じる可能性があります。または（iii）犯罪または不法行為を構成する可能性があります。お客様は、お客様の投稿の作成に関連して上記のいずれの活動にも従事していないし、参加しないことに同意します。上記を制限することなく、お客様は、お客様の提出と併せて、他の人に感情的な苦痛を与えることも、他の人に（公然とそうでないことにも）屈辱を与えないこと、他の人を襲撃したり脅かさないこと、 怪我、死亡、財産上の損害、および/または責任を負う可能性のある行為に他の人が関与しないことを保証するものではありません。 Mobvoi は、 Mobvoi が単独の裁量でそのような活動が発生したと信じている投稿を拒絶します。これらの利用規約の条項に違反していると提出された場合、 Mobvoi は、その裁量により、そのような違反が発生したかどうかを判断し、予告なしにいつでもサイトからその投稿を取り除く権利を留保します。"
        ],
        "terms_7": [
            "7. 不適切な材料",
            "。お客様は、不法な、侵害的、脅迫的、名誉毀損的、猥褻的、ポルノ的、または不敬な内容を投稿または送信するために、アプリまたはサービスを使用することは禁止されています。また、第三者の知的財産を侵害したり不正に流用したり、刑事犯罪とみなされる行為を構成したり煽てたり、民事責任を引き起こしたり、法律に違反する資料を投稿または送信することもできません。お客様はさらに、本契約により、本サービスの利用者に迷惑な広告や「スパム」を送信することが明示的に禁止されていることを理解し、同意します。法令または平等の救済手段に加えて、当社が単独の裁量で、上記の禁止事項または本契約に関連する適用される規則または方針を侵害しているか、または侵害する可能性があると判断した場合、当社は、お客様が当社のサービスに参加すること、および/または通知なくいつでもサービスから関連資料を即座に削除することを禁止することを含め、違反を治癒または防止するために必要と判断する措置を講じることがあります。当社は、法令執行当局または裁判所命令や召喚状に全面的に協力し、そのような資料を掲示している人物の身元を要求するよう指示したり指揮したりします。"
        ],
        "terms_8": [
            "8. ユーザーが発行したコンテンツ",
            "。ユーザーが公開したコンテンツおよびユーザー投稿は、 Mobvoi または Mobvoi に関連する個人の意見を表すものではなく、当社はこのコンテンツを管理しません。いかなる場合においても、ユーザーが公開したコンテンツに対して Mobvoi の承認を直接的または間接的に表明または提案するものではありません。 Mobvoi は、当社のサービスを通じて公開されたアプリまたはユーザー投稿に掲載されたユーザーの公開コンテンツの正確性や信頼性を保証しておらず、コンテンツまたはユーザー投稿そのようなユーザーの査読の結果として生じるいかなる行為に対しても一切責任を負いません。アプリとサービスの使用を通じて、お客様がいやで、不快、有害、不正確または欺瞞的であると思われるコンテンツに暴露される可能性があります。また、未成年者、虚偽の下で行動する人々、国際貿易問題、外国人を扱うリスクもあります。 当社のアプリとサービスを使用することにより、関連するすべてのリスクが想定されます。"
        ],
        "terms_9": [
            "9. コンテスト、懸賞、ゲーム",
            "。時々、 Mobvoi はコンテスト、懸賞、ゲームを提供することがあります。各コンテスト、懸賞、試合への参加には、追加の利用規約が適用されます。"
        ],
        "terms_10": [
            "10. 広告権",
            "。 Mobvoi は、独創的な投稿に関連する広告、帰属、リンク、プロモーションおよび/または配布権を販売、ライセンス供与、および/または表示する権利を有し、 Mobvoi とそのライセンサーまた関連会社は、そのような広告、帰属、リンク、プロモーションまたは配布権の販売またはライセンスから発生したすべての収益を保持する権利があります。これらの追加条項のいかなるものも、Mobvoiに広告、販促、または配布権を販売、ライセンス供与、販売またはライセンス供与する義務を負いません。"
        ],
        "terms_11": [
            "11. 第三者のリンク",
            "。 アプリには、 Mobvoi またはその関連会社が所有、運営または管理していないウェブサイトへのリンクが含まれていることがあります。そのようなリンクはすべてお客様が便利に使えるためにのみ提供されています。これらのリンクを使用する場合、お客様はアプリを終了します。当社および各関連会社は、他のウェブサイト上にある、または他のウェブサイトからアクセス可能なコンテンツ、素材またはその他の情報について責任を負いません。当社および各関連会社は、他のウェブサイトや他のウェブサイト上にある、または他のウェブサイトからアクセス可能なコンテンツ、素材またはその他の情報、または他のウェブサイトを使用して取得した結果について、支持または保証しません。声明または保証も行いません。アプリにリンクされている他のウェブサイトにアクセスすることを決定した場合は、お客様自身が責任をもって完全に行います。"
        ],
        "terms_12": [
            "12. 取引パートナー",
            "。場合によって、当社は他の企業と提携して、アプリ内でサービスを共同プロモーションすることもあります。この場合、相手と直接取引することになります。これらのページでは、取引パートナーのブランドがはっきりと見えます。これらのパートナーのサービスを利用する場合、そのようなパートナーの利用規約に拘束されます。 利用規約を慎重に読むことをお勧めします。"
        ],
        "terms_13": [
            "13. 注文条件",
            "。お客様は、アプリに表示される製品のみを購入することができ、 Mobvoi （香港を含む）が指定した関連地域内の住所に届けられます。お客様は、自分または製品の受信者に個人的に使用するためにのみ製品を購入することができます。 Mobvoi は Mobvoi によって承認された流通経路以外の販売だと信じる合理的な理由がある注文を、拒否することがあります。 Mobvoi は、アプリ上で利用可能な製品やサービスが、指定地域以外の場所での使用に適している、または利用可能であることを保証するものではありません。そのコンテンツが違法または非合法である地域からアプリにアクセスすることは禁止されています。指定地域外の場所からアプリにアクセスする場合は、自己責任で行ってください。お客様はこのアプリから購入した商品を所持、使用、販売する場合は、適用されるすべての国内法および国際法（最低年齢要件を含む）の確認および遵守を行う責任があります。"
        ],
        "terms_14": [
            "14. 製品、コンテンツおよび仕様",
            "。購入可能な製品およびサービスの詳細は、このアプリに記載されています。このアプリに記載、説明された製品およびサービスのすべての機能、コンテンツ、仕様、製品および価格は、予告なしにいつでも変更されることがあります。 特定の重量、尺度および類似の説明は概算であり、利便性の目的でのみ提供されています。パッケージングは示されているものと異なる場合があります。当社は、製品の属性（適用可能な色を含む）を正確に表示するためにあらゆる合理的な努力をしており、実際の色はお使いのコンピュータシステムによって異なりますが、コンピュータがそのような色を正確に表示するかどうかは保証できません。限定時間にアプリにある商品やサービスがいつでも利用可能になることを暗示または保証するものではありません。場合によっては、特定の製品サービスの生産、流通がさまざまな理由により遅延することがあります。そのような場合、当社はお客様に遅れを通知し、訂正された納品スケジュールもお客様に知らせるように合理的に努力します。注文することにより、注文した商品は合法的な方法でのみ使用されることを表明します。"
        ],
        "terms_15": [
            "15. 運送制限",
            "。 注文が行われると、その配送先住所がアプリに含まれている配送制限に準拠している限り、購入者が指定した住所に運送されます。アプリからのすべての購入は、運送契約に基づいて行われます。その結果、アプリから購入されたアイテムを輸送業者からお客様に渡される際に、 商品の損失に対するリスクと権利がお客様に移転されます。商品が損傷された場合や紛失された場合は、お客様は運送業者にクレームを出す必要があります。"
        ],
        "terms_16": [
            "16. 情報の正確さ",
            "。 当社は、アプリにある情報が完全で正確で最新のものであることを保証しようとします。これらの努力にもかかわらず、アプリはときどき不正確、不完全または時代遅れの情報を持つことがあります。当社は、このアプリの情報の完全性、正確性または適時性に関する声明を出しません。たとえば、このアプリに含まれる製品が在庫切れであり、そのプロパティが記載されているプロパティと異なる場合や、実際の価格がアプリに記載されている価格と異なる場合があります。また、予告なしに価格や在庫状況に関する情報を変更することがあります。当社は電子メールで注文を確認しますが、注文書の受領は当社が注文を受理したこと、または製品やサービスを販売するオファーを確認したことを意味するものではありません。当社は、事前の予告なしに、いかなる製品またはサービスの注文数量を制限し、お客様にサービスを提供することを拒否する権利を留保します。また、注文の受け入れおよび/または出荷前に、情報の検証を要求する場合があります。"
        ],
        "terms_17": [
            "17. 料金",
            "。このアプリを通じて販売されるイベント、製品、およびサービスのすべての料金または預金について、Mobvoi、そのベンダーまた代理店は、Mobvoiが提供する銀行カードまたは別の支払い方法に請求します。銀行カード情報、口座番号、必要なその他の情報を当社または当社のベンダーに提供する場合、お客様が、商品やサービスの支払いに使用される銀行カードの正式なユーザーであること、または支払いに使用される代替の支払い方法のアカウントであることを当社に提示します。返済期日までに残高を徴収するため、法的措置が必要な場合は、Mobvoiとそのベンダーまたは代理店に弁護士費用やその他の法的経費を含め、返済予定の総費用を返還することに同意するものとします。お客様は、本アプリに必要なすべてのネットワークアクセスサービスおよびテレコミュニケーションサービスを購入し、関連する料金を支払う責任があります。当社は、支払いおよび預金、損害およびその他の責任の目的で、銀行カードまたは支払い情報を保持および保管します。"
        ],
        "terms_18": [
            "18. サービスの購読条件",
            "。世界中のどこの地域でも、このアプリに提供されているサービスに購読することができます。しかし、Mobvoiは、アプリ上で利用可能なサービスがMobvoiの指定した地域外の場所に適していること、または利用可能であることと約束しておらず、コンテンツが違法または非合法である地域からアプリにアクセスすることは禁止されています。指定地域外の場所からアプリにアクセスする場合は、自己責任で行ってください。お客様は指定された地域以外の場所からアプリにアクセスすることを選択した場合は、自己責任で行ってください。適用されるすべての国内法および国際法（最低年齢要件を含む）の確認および遵守を行う責任があります。"
        ],
        "terms_19": [
            "19. コンテンツを削除する権利",
            "。 当社のプライバシーポリシーに明記されていない限り、当社はユーザーのメールの内容を監視、編集、開示することはありませんが、本アプリおよびそのシステムの通常のメンテナンスのために必要である場合、法律で定められている場合、または誠実な信念でそうした措置が必要な場合を除きます。（1） Mobvoi または本アプリによって提供される法律または法的手続きを遵守すること。（2）Mobvoi、アプリ、または本アプリのユーザの権利または財産を保護し、守ること。（3）緊急時に、お客様、アプリ、または一般の人の安全を守ること。ユーザー自分はメッセージの内容について責任を持ち、 Mobvoi はコンテンツを事前にスクリーニングする義務がありません。しかし、当社は当社独自の裁量により、予告なしに、いつでもアプリに提出された資料を編集、却下、削除する権利を留保するものとします。上記を制限することなく、当社は、本文書の規定に違反したり、またはそうでないと思われる内容を削除する権利を留保します。また、この利用規約に違反するユーザーによりこのアプリへのアクセスを拒否する権利があります。"
        ],
        "terms_20": [
            "20. 終了",
            "。お客様自分または我々が、何らかの理由で、または理由なく、いつでもアカウントまたはアプリの使用を一時停止または終了することができます。お客様は、終了前に自分のアカウントで発生した注文や料金について、個人的責任を負うものとします。当社は、以下の状況でお客様がこのアプリにアクセスするのを妨げる可能性があります。（a）利用規約に違反した場合。（b）お客様が当社に提供する情報を確認または認証することができません。（c）当社は、お客様の行動が、お客様、他のユーザーまたは当社の財務上の損失または法的責任を引き起こす可能性があると考えています。"
        ],
        "terms_21": [
            "21. 声明および保証",
            "。お客様は18歳以上であると声明し、前述の契約を締結する権利と権限を所有しており、本契約の規約、条件、義務を果たすための十分な能力を有し、また、このアプリを使用する際には、適用されるすべての法律を遵守する必要があります。お客様は、本利用規約を読み、理解し、同意し、遵守するものとします。 さらに、お客様自身のユーザ提出物およびそれらの投稿や出版の結果について、単独で責任を負うものとします。ユーザーの提出物について、お客様は次のように確認し、声明し、保証します：（i）お客様は、本契約に基づいて付与されたライセンスに対するすべての同意を得、必要な著作権、特許、商標、営業秘密その他の所有権、または必要なライセンスを所有していること。（ii）必要に応じて、ユーザーが提出したそれぞれの書面により、識別可能な自然人の同意を得て、本アプリおよび本契約に定められた方法で、自分の名前または肖像画を使用することを許可されていること、本自然人は、自分の名前や肖像画を使用されることによって生じる可能性のあるあらゆる責任を免除しています。（iii）お客様は、本契約書の条項を読み、理解し、同意し、これを遵守するものとします。（iv）お客様は今 Mobvoi の代理人ではなく、また過去 Mobvoi の代理人でもなく、 Mobvoi の代理人またはユーザーの提出者の代表でもありません。（v）本契約およびMobvoiアプリの規定に従い、Mobvoiによる提出物の提出および使用は、第三者の権利を侵害するものではなく、知的財産権、プライバシー権、および公衆の権利を含んでますがこれに限定されないです。（vi）お客様がユーザー提出物の作成に参加していなかった、または参加していないこと、お客様が提出物の中に現れたり、あるいは提出物に以下の活動のいずれかがあれば、いかなる人または動物への傷害、誰かに屈辱させる（公的または私的）、誰にでも精神的苦痛を与え、誰かを攻撃または打ち負かす、、不動産の無断破壊、無許可で任意のプロパティを使用する、または民事責任および/または刑事責任を引き起こす可能性のあるその他の作為または不作為。（vii）ユーザー提出物には以下のものは含まれない：（a）または第三者に損害を与え得る重大な虚偽の情報または説明。（b）違法、猥褻、名誉毀傷、名誉毀損、脅迫、ポルノ、嫌がらせ、または犯罪行為の激化または民事責任または法律違反を引き起こすコンテンツ。（c）商業的な広告または誘導。（d）簡単に区別できない第三者を偽装します。"
        ],
        "terms_22": [
            "22. 免責事項",
            "。 このアプリは自己責任で使用してください。本アプリにあるまたはそれを通じて提供される情報、資料およびサービスは、商品性、特定の目的に対する適合性、セキュリティ、または知的財産権の非侵害性の保証を含むのではなく、いかなる種類の保証もなく「そのまま」で提供されます。Mobvoiまたはその関連会社は、このアプリ上にあるまたは本アプリを通じて提供される情報、資料またはサービスの正確性または完全性を保証するものではありません。このアプリ上または本アプリを通じて提供される情報、素材およびサービスは古くなっている可能性がありますが、Mobvoiまたはその関連会社は、これらの情報、素材またはサービスの更新を保証しなく、対応する責任も負うものではありません。上記の条項または黙示の保証を除き、法律で禁止されている範囲には適用されません。このような違法行為については、地域の法律を参考にしてください。口頭または書面によらず、Mobvoiまたは本アプリを通して入手したすべてのアドバイスまた情報は、本書に明示的に記載されている以外の保証を作成しません。"
        ],
        "terms_23": [
            "23. 責任制限",
            "。このアプリおよび/またはサービスにアクセス、使用、または参照している時や、あるいは、このアプリから情報や資料をダウンロードする時など、コンピュータ、通信デバイス、またはその他の財産がウイルスによって損害を受けたり、感染したりした場合、Mobvoiはそれに責任を負いません。いずれにしても、このアプリまたはこのアプリを利用した結果を使用するか使用できないか、または本アプリの一部または全部に含まれる資料、情報またはサービスを使用するか使用できないかにより、お客様自身または他の誰かが、間接的、特別、懲罰的、偶発的または結果的損害をもたらし（利益の損失、データの損失、ビジネス中断の結果を含んでいますがこれに限定されないです）、保証、契約、侵害その他の法的根拠に基づくものであれ、そのような損害の可能性が事前に分かっているかどうかにかかわらず、Mobvoiの役員、取締役、従業員、株主、関連会社、代理人、後任者または譲受人のいずれかが、このアプリの作成、制作、提出に関わる当事者は、いかなる責任も負いません。上記の責任制限は、法律で禁止されている範囲には適用されません。そのような禁止事項については、地域の法律を参照してください。 このアプリおよび/または本サービスまたは本アプリの一部の資料、情報またはサービスに問題がある場合、唯一の救済手段として、お客様はこのアプリの使用を終了することに同意するものとします。いかなる場合でも、お客様が契約、不法行為（過失を含むがこれに限定されない）等により被った損害、損失、訴訟に対する当社の総責任は、以下を超えないものとします。（a）US $ 25.00または同等の国内通貨、（b）このアプリで購入または加入したサービスの価値（2つのうちの高い方）。"
        ],
        "terms_24": [
            "24. 補償",
            "。合理的な弁護士費用を含み、以下に起因する責任、コストおよび費用が発生した場合、お客様は、Mobvoiおよびその関連会社または個人の利益を守り、補償を提供し、損害から保護する必要があります。（i）お客様またはお客様が許可したユーザーがこのアプリまたはインターネットを使用し、あるいは、このアプリに関するメッセージや情報を公表または送信します。（ii）上記の声明および保証のいずれかに違反することを含み、本契約の条件に違反します。（iii）プライバシー、宣伝権、知的財産権を含んでいますがこれに限定されなく、第三者の権利の侵害します。（iv）中華人民共和国またはその他の管轄区域の適用される法律、規則または規制に違反します。（v）お客様がMobvoiに提供するユーザー提出物から生じた請求または損害。（vi）相手方は、このアプリにアクセスして使用するために、お客様の固有のユーザー名、パスワード、または他のセキュリティーコードを使用します。"
        ],
        "terms_25": [
            "25.免除",
            "。 このアプリの1人または複数の他のユーザーと紛争を起こした場合は、紛争の原因または紛争の種類や性質に関係なく、Mobvoi（及び当社の役員、取締役、代理人、子会社、合弁会社および従業員）を既知及び未知の、疑われ及び思いも寄らない、開示された及び未公開のクレーム、要求および損害（実際的および結果的）から免除する必要があります。"
        ],
        "terms_26": [
            "26. 不可抗力",
            "。Mobvoiまたお客様は、合理的な支配を超える行為または行為に起因する損害またはパフォーマンスの遅延または失敗の責任を負わないものとします。これらを含んでいますが、限定されるものではないです。火災、ライトニング、爆発、電力サージまたは障害、水災、神の行為、戦争、革命、民事訴訟、軍事当局または公共の敵：政府、法律機関、またはそのような政府または法的機関の代表者の法律、命令、規則、条例、または要求；労働争議は、ストライキ、欠勤、ピケ、ボイコットのほかに、原材料、輸送施設、燃料へのアクセスできない、エネルギー不足、その他の公共運送業者の行為や不作為を含んでいますが、制限されないです。"
        ],
        "terms_27": [
            "27. プライバシー",
            "。個人情報の収集および使用を含むデータの収集および使用には、関連するMobvoiのプライバシーポリシーによって支配されています。その関連するアプリまたはサービスは指定された領域に適用され、本契約に組み込まれ、本契約の一部です。"
        ],
        "terms_28": [
            "28. 概要",
            "。このアプリおよびそれに含まれる資料、ならびにこのアプリおよびそれに含まれる資料の使用に関する主張は、中華人民共和国の法律に準拠しています。これらの利用規約に基づいて、または関連する司法手続きまたは行政手続において、これらの利用規約の印刷版を受理することはできますが、当初生成され、印刷された他のビジネス文書およびレコードと同じ範囲内に保管され、それらの文書およびレコードと同じ条件に従わなければなりません。",
            "本利用規約に起因または関連して発生するすべての紛争は、北京海淀区人民裁判所の専属管轄権を有するものとし、裁判所は訴訟を承諾するものとします。",
            "当社は、このアプリへの継続的で、妨げられないまたは安全なアクセスを保証するものではなく、このアプリの運営は、当社が支配できない多くの要因によって妨げられる可能性があります。",
            "これらのサービス条項のいずれかが無効または強制不可能であると判明した場合、その条項を削除され、残りの条項は引き続き実行可能です。",
            "お客様は、Mobvoiが独自の裁量により、本利用規約とそれが対象とするすべての契約を自動的に転送することと同意するものとします。",
            "本契約で使用されるタイトルは利便性のためにのみ意図されており、このセクションの範囲または範囲の定義、制限、解釈または説明は意図されていません。",
            "当社は、お客様や他の人による契約違反に対して行動しなかったとしても、それにフォローオンまたは同様の違反行為に関して行動する権利を放棄することを意味するものではありません。",
            "この利用規約は、本契約の対象に関する当事者間の完全な理解と合意を構成します。コンテキストが各セクションで規定された場合、本契約の終了または満了まで有効です。"
        ],
        "terms_29": [
            "29. 追加援助",
            "。 上記のサービス利用規約のいずれかを理解していない場合やご不明な点がございましたら、{supportEmail}まで電子メールでカスタマーサービス部門にご連絡ください。"
        ],
        "terms_30": [
            "30. 著作権に関するお知らせ",
            "。すべてのデザイン、グラフィックス、テキスト選択、手配、およびすべてのソフトウェアは、Mobvoi Information Technology Company Limitedおよびその関連会社またはそのライセンサーの著作権©2018です。全著作権所有。"
        ],
        "terms_31": [
            "31. オンライン取引",
            "。オンラインで販売される製品およびサービス[www.mobvoi.com]の場合、そのようなオンライン取引の基礎となる購入契約の当事者は[HK SMARTMV LIMITED]および購入注文をしたユーザーです。 これらの利用規約は、このようなオンライントランザクションには適用されず、別の利用規約（オンライントランザクション）が適用されます。"
        ]
    },
    "privacy_policy": {
        "title": "プライバシーポリシー",
        "update_time": "最終更新：2020年5月26日(本ポリシーは2020年5月26日から効力を発します)",
        "para_1": "Mobvoiをご利用いただき、ありがとうございます。",
        "para_2": [
            "お客様の個人情報は我々にとっては重要です。Mobvoiはお客様の権利を尊重します。本プライバシーポリシーはMobvoiはどんな会社か、どうやってお客様の個人情報を集約・シェア・取り扱いしているか、お客様としてどうやって自分の個人情報権利を行使するのか、を説明しています。本プライバシーポリシーはMobvoiアプリ、Ticwatch一連の設備、Mobvoi(「 Mobvoiサービス」 或いは「 Mobvoi の サービス」も同様)が生産したTicwatch一連のスマートスピーカに適用します。"
        ],
        "para_3": [
            "お客様のMobvoiサービス言語は英語であれば、現在の操作システムは Wear OS by Google（以前はAndroid Wear） によって働きます。MobvoiはWear OS by Googleを所有や制御しません。Wear OS by Googleは使われている間には直接にWear OS by Googleや選ばれた他の第三者に情報を供給することができます。それらの第三者は情報の集約、取り扱い、公表に対して、独自のルールを持っいるため、それらのプライバシーポリシーをもう一度読んだほうが良いです。"
        ],
        "para_4": [
            "ポリシーの中、「Mobvoi」 、「We（我々）」 、「Us（我々） 」 、或いは「Our（我々の） 」 はMobvoi Information Technology Company Limitedを示し、本プライバシーポリシーによってお客様の情報に責任を持ちます(「データコントローラ」 )。"
        ],
        "para_5": "お客様個人情報の取り扱いについて、ご質問や気になることがあれば、本プライバシーポリシー文末の連絡先によって連絡ください。",
        "quick_link": "Quick links",
        "para_6": "We recommend that you read this Privacy Policy in full to ensure you are fully informed. However, if you only want to access a particular section of this Privacy Policy, then you can click on the relevant link below to jump to that section.",
        "terms_1": {
            "q": "1. Mobvoiは何をするか",
            "para": [
                "Mobvoi Information Technology Company Limitedとすべての提携会社は人工知能会社であり、本社は中国の北京にあるが、グループ会社は世界中のいろいろな地域にあります。我々はボイスに基づいた技術によってサービスを提供しています。この技術によって、MobvoiやMobvoiが承認した協力者は人間―コンピューターインタラクションでお客様にパーソナライズライフアシスタントサービスを提供することができます。",
                "Mobvoiに関するもっと詳しい情報については、ウェブサイトhttps://www.mobvoi.com/pages/about-us.で「我々について」との部分をご覧ください。"
            ]
        },
        "terms_2": {
            "q": "2. 個人情報処理の法律根拠",
            "para": [
                "お客様は欧州経済領域にいる場合、以上で説明している我々の個人情報集約、利用の法律根拠は関係個人情報や集約した情報の具体的状況に従うが、我々は正常的な集約方法しかお客様のところから個人情報を取りません。",
                "(i)どこに個人情報を利用してお客様に連絡しているか(ii) どこまでは情報の処理は正当な利益範囲にあり、お客様の権利をオーバライドしないか、或いは(iii)どこまではお客様に認められているか。場合によって、お客様の個人情報を集約する法律義務あるケースがあり、また、国益や他の人の利益を保護するためにお客様の個人情報を集約するケースがあります。",
                "法律によって必要やお客様に連絡を取るために個人情報を要請の場合、お客様に知らせて、個人情報の提供は強制であるかどうかをはっきりします。（お客様が個人情報を提供しない可能性もあります）。",
                "正当な利益（或いはいずれの第三者）のためお客様の個人情報を集約・利用する場合、その利益は我々のプラートフォームの管理に使かわれ、我々のサービスの提供や我々の正当的な商業利益のため必要な時にお客様に伝達します。必要な時とは、例えば、お客様の質問を回答する時、我々のプレートフォームを改善する時、マーケティングを引き受ける時、或いは検知するや法律違反活動を防止する目的がある時です。それ以外の正当な利益もあるかもしれないが、個人情報を取る前にお客様にどんな正当な利益かを説明します。",
                "ご質問がある場合、あるいは個人情報の集約・利用に対してもっと詳しい情報がご利用いただきたい時、「我々への連絡方」に詳細な連絡方が記載していますので、ご利用ください。"
            ]
        },
        "terms_3": {
            "q": "3. お客様個人情報の集約方法",
            "para": "Mobvoiのサービスをご利用いただく時、お客様の個人情報を要請・取得します。",
            "title_3_1": "3.1 自発的に提供した情報について",
            "content_3_1": [
                "Mobvoi をご利用いただくため、自発的にお客様の個人情報を提供することを要請します。情報要請の理由について、情報要請時にはっきりお客様に説明します。",
                "Mobvoi利用に必要な情報しか要請しません.",
                "要請された情報はMobvoi サービス機能の実現に使い、そういう情報がないとお客様希望の通りにサービスを提供することができません。"
            ],
            "ul_1_1": [
                "アカウント情報について。 ",
                "Mobvoiアカウントを作る時、確定な情報、例えば名前、電話番号、メールアドレスを要請します。"
            ],
            "para_3_1": [
                "個人情報の提供はお客様のご希望によります。",
                "もっとよい利用体験を作るため、追加情報として個人情報を提供することもできます。追加情報はお客様の承認ないと勝てに処理しません。",
                "お客様が Ticwatch S & E をご利用になる時、その情報を Wear OS by Google に提供要請もあります。Wear OS by Googleや他のGoogle アプリが情報要請する時に必ず事前にお客様にお知らせます。"
            ],
            "ul_1_2": {
                "li_1": [
                    "追加の個人紹介情報について。",
                    " 自分のMobvoi紹介(例えば性別、写真、ニックネーム、誕生日、共通アドレス、メールアドレス)として追加個人情報を提供することができます。"
                ],
                "li_2": [
                    "お客様の生理的な情報について。",
                    " フィットネスアプリやヘルスアプリ、ステップランキングアプリ、ダイヤルプレイトをご利用になる時に生理的特長、スポーツ、ヘルスを提供することができます。例えば、身長や体重、ステップナンバー、カロリー摂取量、スポーツモード(i.e.ランニング或いはウオーキング)、ウオーキング距離。"
                ],
                "li_3": [
                    "敏感な個人情報のリマインドについて。",
                    " お客様が提供している個人情報の中、敏感な個人情報例えば個人の健康状況が含まれる可能性があります。そのような情報は他の情報ようもっと重視されていますが、敏感な情報を提供する前、まず提供に適切かどうかをはっきり考えたほうがよいです。提供した後、お客様が自分の敏感な個人情報をプライバシーポリシーに記載の通りに使われることを認めることになります。もちろん、お客様がそれを拒否する権利があります。第7部分お客様個人情報管理に対する権利についてをご参照ください。"
                ],
                "li_4": [
                    "共有の個人情報",
                    " にはMobvoiに提供したお客様の個人情報或いはお客様に関する情報があります。お客様がMobvoiアカウントに貼ってある情報（公表されている情報、Mobvoiアカウントのユーザ名、ユーザ写真、ブルートゥース、承認されたカメラ或いはラジオからのビデオやレコーディング含む）、Mobvoiの他のユーザが共有しているお客様に関する情報(ローケーションとログ情報含む)が含まれています。"
                ]
            },
            "title_3_2": "3.2 Mobvoi サービスのご利用によって自動的に集約した情報について。",
            "content_3_2": [
                "Mobvoi サービスをご利用の時に自動的にご利用の設備から情報集約します。EEAも含めて国によって、それがデータ保護法律を守るように考慮する必要があります。",
                "具体的には、我々が自動的に集約した情報の中、お客様のIPアドレスや設備タイプ、設備独有のID番号、ブラウザータイプ、広い地理的ローケーション(e.g. 国或いは都市レベルのローケーション)、他のテクニカル情報があります。それ以外、お客様がご利用の設備がどうやって我々のウェブサイトに繋がっているか、ウェブページの接続、リングのクリックなどの情報もあります。",
                "それらの情報の集約によって、我々はお客様をもっと理解することができます。集約した情報を利用して、例えは、お客様の好みや趣味、ローケーションを分析することによって、もっとお客様に適するサービスを提供します（例えば正しくご移動ルートをレコードし、もっとお客様の希望に合う公告やプロモーション情報を提供する）。",
                "これらの情報は予想機能の実現に必要であり、情報の利用によって法的義務の実現やMobvoiサービス機能の提供・改善が可能となります。"
            ],
            "ul_2": {
                "li_1": [
                    "ローケーション情報。",
                    " Mobvoiをご利用時の設備ローテーション、例えばGPSやwifi 、コンパス、アクセロメーター、その他のモバイル設備の利用センサーなど、設備或いはMobvoiに接続するインターネットサービスのインターネットプロトコールアドレス(IP アドレス)。"
                ],
                "li_2": [
                    "ログ情報。 ",
                    "クッキー、ウェブビーコン、ログファイルの利用やスクリプト・電子ラベルのプログラムを通じてMobvoiをご利用になる時に自動的にお客様の情報を集約し、クッキーや類似の技術を利用することもっと学習します。"
                ],
                "li_3": [
                    "技術的情報。",
                    " 自動的にお客様のモバイルオペレータ、ウェブブラウザー、或いはお客様が提供したMobvoiの他のプログラムに接続するためのセッティング情報、お客様の設備のIPアドレス、バーション、ID番号(例えばIMEI 番号とAndroid ID)等の技術的情報を集約します。"
                ],
                "li_4": [
                    "Mobvoiのコンミュニケーション情報。",
                    " 例えばコンミュニケーション時ディーエーユーをアカウントするためのデータと継続時間。"
                ]
            },
            "title_3_3": "3.3 第三者から取れた情報について",
            "content_3_3": [
                "時々第三者から個人情報を取れているが、当該第三社がお客様の承認を得たことを確認した上、或いは法律によって情報を入手しています。",
                "第三者から取れた情報にはアカウント情報があります。我々はその情報を利用してMobvoi アカウントを作り、持っているお客様のレコードを正確的に改善することに使います。",
                "それたの第三者が情報の集約・利用・共有に対して自分独自のルールが持っています。それぞれのプライバシーポリシーをもう一度読んだほうがよいです。"
            ],
            "title_3_4": "3.4 エッセンシャルモードでのデータ測定",
            "content_3_4": "Ticwatch.はエッセンシャルモードでセンサーによってハートレートやステップを測定します。エッセンシャルモードでそのデータを確認できますが、アプリに記録のことやサーバに載せることはないです。"
        },
        "terms_4": {
            "q": "4. どのようにお客様の個人情報を使用しているか",
            "para": "我々はお客様の個人情報含む情報を利用・保存・処理して、Mobvoi サービスを提供・理解・改善に使い、信じられる安全な環境を作りたて・保持し、我々の法的義務を守ります。",
            "title_4_1": "4.1 Mobvoiサービスの提供・改善・発展について",
            "ul_1": {
                "li_1": "Mobvoi サービス(Mobvoiサービスの特有機能も含む)を提供のため、例えば、Mobvoi ソフトウェアのBluetoothを利用して話しし、自分のローケーションによって関係コンテントをディスプレーします。",
                "li_2": "ロジスティクの配達、オーターインコリ、、オンラインストーで購入した製品のアフターサービスを提供するため。",
                "li_3": "Mobvoi サービスの間にお客様の個人情報を共有する目的です。Mobvoi 設備をご利用になる時に集約した個人情報は他のMobvoi 設備に使って特定のサービスを提供することができます。お客様によって、保存されている個人情報がMobvoiサービス間にトラスファー・トランスミットすることができます(可能な場合)。"
            },
            "para_4_1": "これらの情報を正当な利益のためにプロセスして、これらの情報を利用してMobvoi サービスや必要な予想機能を改善します。",
            "title_4_2": "4.2 安全な環境を作り・保持",
            "ul_2": {
                "li_1": [
                    "お客様サービス、セキュリティ、不正利用検知、アーカイブ・バックアップ (我々が提供しているラインをつけているMobvoi Terms of Serviceと他のMobvoiポリシーの中に記載している通り)"
                ],
                "li_2": "我々の法的義務によるもの"
            },
            "para_4_2": "Mobvoiサービスを保護する法的利益を記載する情報をプロセスします。予想機能をはかり根拠法律を守る",
            "title_4_3": "4.3 広告とマーケーティングを提供、カスタマイズ、改善",
            "ul_3": {
                "li_1": "Mobvoiサービスをご利用になるい理由をもっと理解し、Mobvoiサービスを改善し、新しいサービスを開発し、ユーザの希望や好み(言語設定、ロケーション設定、個人的サポートサービス、インストラクション含む)に合い、お客様や他のMobvoiユーザのほかの要請に合う目的です。",
                "li_2": "製品プレゼンティション、個人的リコーメンディション、販売促進情報、例えば航空・船便旅行、映画館映画日程、地方の天気変化メッセージ、気になるニュース・トピックス等のため。"
            },
            "para_4_3": "我々はこの部分に記載している目的のためお客様の個人情報をプロセスします。マーケーティング活動でお客様に製品やサービスを提供することによって我々の法的利益を実現します。アンサブすくライブインストラクション（我々のマーケーティングコンミュニケーションやMobvoiアカウントの告知セッティングの変更含む）によって我々からのマーケティングコンミュ二ケーションをオプトアウトすることができます。",
            "title_4_4": "4.4 一般的には、我々はお客様から集約した個人情報を本ポリシーに記載している目的、或いは情報集約の時に説明した通りに使います。しかし、それ以外にもお客様の個人情報を利用すること場合があります。社会利益、科学リサーチ、歴史リサーチ、統計、データ保護法律が認めている出版のため以外は、事前にお客様に連絡します。",
            "title_4_5": [
                "4.5 Mobvoiの利用規約における個人情報の利用についての協議或いは条項（あれば）も本プライバシーポリシーの対象となっています。"
            ]
        },
        "terms_5": {
            "q": "5. お客様の個人情報を共有、譲渡、公開、開示および保持すること",
            "desc": "We do not share personal information with other companies, organizations and individuals unless one of the following circumstances applies:",
            "title_5_1": "5.1 お客様の同意を取得すること",
            "para_5_1": "下記条件の以外、お客様の同意がない限り、個人情報を他の当事者と共有したり、譲渡したり、開示したりすることは絶対にしません。",
            "title_5_2": "5.2 情報を合法的に処理する他の手段",
            "ul_2": {
                "li_1": [
                    "お客様の個人情報を法的執行機関、規制当局、政府機関、裁判所または他の第三者に公開する必要がある場合：（i）適用される法律または規制問題としての場合（ii）当社の法的権利を行使、確立または擁護する場合（iii）お客様の重要な利益または他人の利益を守る場合（iv）お客様のの権利と自由がこれらの利益を上回らない場合は、我々は正当な利益を追求します。"
                ]
            },
            "title_5_3": "5.3 関連会社",
            "para_5_3": [
                "TMobvoiのサービスを提供するため、我々はお客様の情報（個人情報を含む）を当社の関連会社内で共有する可能性があります。でも、当社は必要な個人情報のみを共有させます。そして、我々はプライバシーポリシーに記載された目的にも拘束されます。もし関連会社が個人情報の処理目的を変更する場合は、お客様の再認可および再同意を求める必要があります。したがって、関連会社の詳細をもっとご覧ください。データ共有は、お客様と当社との間の契約履行には必要です。"
            ],
            "title_5_4": "5.4 サービスプロバイダ",
            "ul_4": {
                "li_1": "お客様の個人情報の一部をパートナーと共有してお客様と契約を結ぶ場合があります。サービスプロバイダーは、欧州経済地域（EEA）の内部か外部に設置されています。特に、当社のサービスプロバイダーは、ヨーロッパ、インド、アジア太平洋および北米に拠点を置いています。",
                "li_2": [
                    "我々は、下記目的のために、世界的なビジネスをサポートしてくれるサービスプロバイダーに必要な情報を提供します。1) Mobvoiサービス提供の協力。2) 「お客様の個人情報の使用方法」 に記載されている目的を達成するための支援。3）Mobvoi利用規約または本プライバシーポリシーに基づき当社の責任を果たし、当社の権利を執行し、かつ/または当社サービスの理解と改善を支援する。4）技術基盤サービスの提供、サービスの利用形態の分析、広告、サービス、支払い利便性の測定、学術調査と調査の実施。"
                ],
                "li_3": "例えば、配達サプライヤにとって必要な配達先、電子メールを送信したり、通知を送信したりする通信サービス。",
                "li_4": "我々は、お客様の個人情報を合法的、合理的、必要、具体的、明示的な目的でのみ共有します。そして、これらのプロバイダーは契約に約束され、公開目的が本プライバシーポリシーに一致しない場合、お客様の情報へのアクセスが制限され、タスクが実行できません。"
            },
            "title_5_5": "5.5 認可された広告および分析サービスパートナー",
            "para_5_5": "お客様の同意を得る場合のみ、我々は広告および分析サービスパートナーにお客様の個人情報を共有します。広告の掲載範囲や有効性に関 する 情報はパートナーに提供しますが、お客様の個人情報は提供しなく、またはお客様の身元が識別されないようにこれらの情報を集約するかもしれません。たとえば、広告のお客様が広告ガイドラインを遵守することに同意する場合、広告の聴衆人口や広告の影響を受ける人の数、または個人で識別できない人口統計情報（例：「ソフトウェア開発の習慣を持つフランスの25歳の男性」）などを提供して視聴者や顧客への理解を支援します。",
            "title_5_6": "5.6 ビジネス移転",
            "para_5_6": "Mobvoiが合併、買収、再編、資産の売却、破産または破産事件を引き受ける場合、当社はかかる取引または熟考に関連するお客様の情報を含んで資産の一部または全部を売却、譲渡または共有するかもしれません。お客様のそのような取引（デューデリジェンスなど）に関する情報も含まれています。この場合、当社は、お客様の個人情報を保持する新しい企業または団体に対し、引き続き本プライバシーポリシーに拘束される条約の順守を要求します。そうではなければ、企業または団体にお客様からの再認証および再同意を求める必要があるように要求します。",
            "title_5_7": "5.7 データ集計",
            "para_5_7": "また、規制遵守、業界・市場分析、人口統計プロファイリング、マーケティングおよび広告、ビジネスに関するその他の業務目的のため、集約された情報（ユーザーの情報を結合して個々のユーザーが識別されないように）および他の匿名化された情報を共有しています。",
            "title_5_8": "5.8 第三者との個人情報の処理に関する注意",
            "para_5_8": "当社または当社の関連会社が、当社のサービスの提供および改善を支援するために、お客様の個人情報を第三者と共有する必要がある場合、データをどのように使用し開示するかについても厳格な制限が課せられます。例えば、我々は第三者と厳重な秘密保持契約を結び、次のような場合のみ第三者がお客様の個人情報を使用できます。（i）本プライバシーポリシーを遵守します。（ii）実行した適切な機密保護とセキュリティ手段を含め、第三者に発行した他の指示を遵守します。当社は、これらのパートナーに集約された情報、匿名化された情報、または他の非身元情報を提供する場合があります。"
        },
        "terms_6": {
            "q": "6. お客様の個人情報の保護方法",
            "title_6_1": "6.1 当社は個人情報の収集及び処理を保護し、不正な訪問、情報公開、使用、変更、破損または損失を防ぐために、業界標準に準拠した安全保護対策をとっています。そして、お客様の個人情報を処理するリスクに対して、適切なレベルのセキュリティを提供するように設計されています。例えば、お客様はブラウザと「サービス」の間でデータを交換するとき（クレジットカード情報など）、SSL暗号化に保護されています。我々はプライバシーポリシーのホームページに出るウェブサイトにHTTPSセーフブラウジング方法を提供します。そして、データの機密性を確保するため、暗号化技術も使用されています。また、我々は自立保護メカニズムを利用してデータの悪意攻撃を防止します。アクセス制御機構を導入して許可された人だけが個人情報にアクセスできるように設定しています。そして、社員の個人情報保護の意識を強化させるため、安全とプライバシー保護に関する教育も実施しました。",
            "title_6_2": "6.2 個人データ侵害の場合、データ・コントローラーであるMobvoiは、違反が本人の権利と自由に危険をもたらす可能性が低い場合を除き、遅延なしに（通常72時間以内に）監督当局に通知する法的義務を負っています。",
            "title_6_3": "6.3 我々は無関係の個人情報を収集しないため、合理的に実行可能なすべての対策をとります。法律が許可される場合を除いて、規定期間内にプライバシーポリシーに記載された目的を達成するため、お客様の個人情報だけを保留します。",
            "title_6_4": "6.4 インターネットは絶対な安全環境ではなく、他のMobvoiユーザーとの電子メール、インスタントメッセージおよび他の通信形態は暗号化されていません。したがって、機密情報を送信しないことを強くお勧めします。アカウント保護のため、複雑なパスワーをご使用ください。",
            "title_6_5": "6.5 インターネット環境が絶対的に安全であるとは限らないので、我々はなるべく送信情報のセキュリティを確保します。個人情報保護事件の不幸な出来事の中で、我々は法律および法規の要求に従ってそのような事情の基本状況、可能性のある影響、我々が取ったまたは取り上げる対策、リスク軽減、是正措置及び予防方法などを含んで、速やかにお客様に通知します。そして、電子メール、手紙、電話、および通知などを通して、イベントの関連状況をタイムリーにお知らせします。"
        },
        "terms_7": {
            "q": "7. お客様個人情報管理に対する権利について",
            "para": "欧州経済圏と香港の居住者である場合は、以下のデータ保護の権利があります。",
            "title_7_1": "7.1 アクセス権",
            "para_7_1": [
                "法律および規制によって禁止されている場合を除き、ご個人情報にアクセスする権利があります。アクセス権を行使したい場合は、以下の方法があります。",
                "上記のリンクを通じて個人情報にアクセスできない場合、または上記のリンクにアクセスしても個人情報が記載されていない場合は、{supportEmail}まで電子メールを送信してください。我々は遅滞なく、またいかなる場合でも、要求の受領後1ヶ月以内に対応します。",
                "過度の時間を要さないの前提で、我々は当社の製品またはサービスを使用するときに限り、他の個人情報をお提供します。データアクセスを行おうとする場合は、{supportEmail}まで電子メールを送ってください。"
            ],
            "ul_1": {
                "li_1": [
                    "a) ",
                    "アカウント情報",
                    " -- 個人情報や支払い情報のアクセスや編集、パスワードの変更、安全情報の追加またはアカウントの閉鎖などができます。操作方法は、「Mobvoiアプリケーション」→「ユーザセンター」です。"
                ],
                "li_2": [
                    "b) ",
                    "検索情報",
                    " -- 「Mobvoiアプリケーション」→「ユーザセンター」にアクセスして、検索履歴にアクセスしたり、検索履歴を消去したり、興味を表示・編集したり、他のデータを管理したりすることができます。"
                ]
            },
            "title_7_2": "7.2 修正権利",
            "para_7_2": [
                "個人情報が処理されているとき、不正確または不完全な個人情報を見つけた場合は、その情報を修正するように要求できます。そして、「Mobvoiアプリケーション」→「ユーザセンター」で自分で修正することもできます。",
                "上記のリンクを通して個人情報が修正できない場合は、{supportEmail}にEメールを送信して訂正請求を提出してください。我々は遅滞なく訂正請求を受領後1ヶ月以内に対応します。"
            ],
            "title_7_3": [
                "7.3 消去権利（「忘れられる権利」）"
            ],
            "para_7_3": [
                "次のような状況では、個人情報の削除が要求できます。 ",
                "{supportEmail}に電子メールを送信して個人情報の消去が要求できます。我々はリクエストの受領後1ヶ月以内に遅滞なく返信いたします。",
                "Mobvoiサービスから情報を削除すると、我々はバックアップシステムから情報を直ちに削除することはできません。でも、バックアップシステムのアップデートが予定されている場合は、その情報が削除されます。"
            ],
            "ul_3": {
                "li_1": "a) 法令違反で個人情報を処理します。",
                "li_2": "b) お客様の同意なくお客様の個人情報を収集し使用します。",
                "li_3": "c) 合意に違反して個人情報を処理します。",
                "li_4": "d) 当社製品やサービスを使用しない場合、またはMobvoiアカウントをキャンセルした場合。",
                "li_5": "e) Mobvoiがあなたにサービスを提供しない場合。"
            },
            "title_7_4": [
                "7.4 さらに、個人情報の処理を拒否したり、制限したり、個人情報の可搬性を要求したりすることもできます。そして、{supportEmail}にEメールを送信してこれらの権利を行使することができます。我々はリクエストの受領から1ヶ月以内に遅滞なく返信します。"
            ],
            "title_7_5": "7.5 お客様の許可と同意の範囲を変更する",
            "para_7_5": [
                "各機能には基本的な個人情報が必要とします（当該プライバシーポリシーのセクション3を参照）。お客様は【携帯電話の設定を入力→Mobvoi】を操作して個人情報の収集・使用するとき、同意を授与または撤回することができます。",
                "同意を取り消すと、個人情報は処理されません。ただし、同意を取り消しても、以前承認した個人情報の処理には影響しません。また、同意以外の合法的な処理の根拠に基づいて行われる個人情報の処理にも影響しません。"
            ],
            "title_7_6": [
                "7.6 いつも送信されているマーケティングコミュニケーションのアウトプット権利"
            ],
            "para_7_6": [
                "この権利は、送られたマーケティング電子メールの中の「購読中止」リンクをクリックすることによって行使できます。他のマーケティング宣伝広告（郵便または電話販売とか）を希望しない場合、「我々との連絡方法」に記載されている情報を参照して連絡ください。"
            ],
            "title_7_7": "7.7 データの移植性",
            "para_7_7": [
                "お客様は{supportEmail}にEメールを送信することで自分の個人情報のコピーを取得する権利を有します。我々はリクエストの受領後1ヶ月以内に遅滞なく処理します。",
                "技術的に可能であれば（データインターフェースなど）、お客様のご要望により、お客様の個人情報のコピーを指定された第三者に直接送信することもできます。"
            ],
            "title_7_8": "7.8 クレームの権利",
            "para_7_8": "データ保護機関が規定された個人情報の収集・利用についての要求を守る権利が必要です。詳細内容は現地のデータ保護機関と連絡ください。",
            "title_7_9": "7.9 ご要求への対応",
            "para_7_9": [
                "セキュリティ保護と身元確認のため、書面または他の方法でリクエストを提供する必要があります。ご要求により、どんなことがあっても請求を受領後1ヶ月以内に必ずご対応します。",
                "原則として、お客様の合理的な請求は無料です。ただし、複数回繰り返され、合理的な制限を超えたリクエストについては、一定の料金を請求します。もし過度に繰り返したり、多くの時間がかかる技術方法が必要な場合（新しいシステム開発要または現状を徹底的に変えること）または他の合法的権利にリスクを与える場合、または現実ではない場合（テープかハードディスクに保存されている情報）、ご請求を対応できません。"
            ]
        },
        "terms_8": {
            "q": "8. お知らせ",
            "title_8_1": "8.1 通知および他のタイプの通信",
            "para_8_1": "Mobvoiサービスを使用する際には、個人情報を使用して電子メール、テキストメッセージ、またはプッシュ通知がデバイスに送信されます。もしこれらの受信を希望しない場合は、デバイスに「キャンセル通知」がある場合はそれを選択するか、{supportEmail}までご連絡ください。",
            "title_8_2": "8.2 サービス関連のアナウンス",
            "para_8_2": "当社は、必要に応じてサービスに関するお知らせを随時送付することがあります（たとえば、保全のためにMobvoiサービスを一時停止する場合など）。そのようなお知らせは、サービス関連であるがプロモーションに関連しているものではないため、キャンセルする権利がありません。"
        },
        "terms_9": {
            "q": "9. 第三方会社及び＆インテグレーション",
            "para": [
                "Mobvoiサービスは第三者ウェブサイト・サービスのリンクを含む場合があります。例えば、第三者インテグレーション、ブランドサービスか第三者ブランドサービス（第三者パートナー）。でも、Mobvoiは第三者パートナーをコントロール・所有しないので、お客様は第三者パートナーとやり取りするとき、直接に第三者パートナーかMobvoi、あるいはその両方に情報を提供することが可能です。そして、第三者パートナーは自分の規定に基づいて情報を収集・利用・公開しますから、アクセスする時そのウェブサイトのプライバシーポリシーを確認しておいて下さい。"
            ],
            "terms_9_1": [
                "",
                ""
            ]
        },
        "terms_10": {
            "q": "10. データ保持",
            "para": [
                "当社はお客様から収集した個人情報を正当なビジネス上の必要性がある場合に限り保持します。例えば、法令、税務または会計上の要求事項を遵守することまたは必要なサービスをお客様に提供することなど。",
                "継続的な正当なビジネスニーズではない場合、当社はその個人情報を削除または匿名化するか、または削除不可と匿名化不可の場合（例えば、お客様の個人情報が既にバックアップアーカイブに保存されているなど）、お客様の個人情報をさらに安全に保存すると同時に削除が可能になるまでそれ以上の処理から隔離します。"
            ]
        },
        "terms_11": {
            "q": "11. グローバルオペレーションと国際データ転送",
            "para": [
                "我々は全世界でサービスを提供しています。お客様の国の法律により許可されている場合は、米国、中国本土および当社が運営する他の国においてもお客様の個人情報を転送、保管、使用することが許可されます。でも、我々が個人情報を譲渡する国の中には、政府当局がデータにアクセスする際のプライバシーおよびデータ保護の法律および規則があなたの国のと異なる場合があります。",
                "具体的にいえば、当社のサーバーは中国本土にあり、当社および第三者のサービスプロバイダーおよびパートナーは世界中で事業を行っています。お客様の個人情報を収集する際に、これらの国々で処理する可能性があることを意味しています。",
                "EEAの外部で個人データを転送する際には、受領国のデータ保護法の妥当性、データの受領者に対する契約上の義務（モデル条項が要求されることがある）に基づいて、データ主体の権利を適切に保護する以下に述べるような照会によって）、またはEU-USおよびスイス・アメリカプライバシーシールドの原則に従います。",
                "現在、私どもは適切な保護措置をとってお客様の個人情報がこのプライバシーポリシーに従って保護されたようにしています。これには、グループ会社間で個人情報の譲渡に関する欧州委員会の標準契約条項を実施することが含まれます。この契約条項は、欧州連合のデータ保護法に従って、すべてのグループ会社がEEAから処理する個人情報を保護することを求めています。",
                "お客様は{supportEmail}に電子メールを送ることによって標準契約条項に対する要求が提出できます。当社は、第三者のサービス提供者およびパートナーと同様の適切なセーフガードを実施しており、要望に応じて詳細を提供することができます。"
            ]
        },
        "terms_12": {
            "q": "12. クッキーおよび他の追跡技術の使用方法",
            "para": [
                "当社はクッキーおよび類似の追跡技術（総称して「クッキー」）を使用して客様の個人情報を収集します。使用されているCookieの種類、理由、Cookieの制御方法については、Cookieポリシーを参照してください。"
            ]
        },
        "terms_13": {
            "q": "13. 子供の個人情報の対応方法",
            "title_13_1": "13.1 Mobvoiのサービスは子供向けではありません。EEAで16歳未満の居住者については、両親または保護者の同意なしには当社のサービスを利用できません。13歳から16歳のEEA居住者の場合、両親や保護者が合法的な同意を得てサービスを利用できるかどうかは、ご国の国内法律によります。",
            "title_13_2": "13.2 子供向けのMobvoiの製品またはサービス（子供のスマートウォッチなど）については、あなたがお子様の親または保護者であることを承諾し、子供を代理してこのプライバシーポリシーに同意する権利があり、子供の情報が収集・処理されることを許可してこのプライバシーポリシーに記載された目的および方法を達成します。",
            "title_13_3": "13.3 EEAの居住者であるMobvoiユーザーが16歳になると、親と保護者の同意が無効になり、個人情報の提供・共有に同意するか、または提供済の個人情報を削除するか、自分で決める権利を有します。",
            "title_13_4": "13.4 保護者の同意を得ずに子供の個人情報を収集する場合、我々は過度の遅滞なく関連するデータを削除します。"
        },
        "terms_14": {
            "q": "14. プライバシーポリシーの更新",
            "title_14_1": "14.1 我々は時々プライバシーポリシーを更新するかもしれません。当該プライバシーポリシーを変更すると、改訂されたプライバシーポリシーがウェブサイトに掲載され、同時にプライバシーポリシーの先頭に「最終更新日」の日付も更新されます。",
            "title_14_2": "14.2 サービスを継続使用する前に、改訂されたポリシーを確認する必要があります。改訂されたプライバシーポリシーに同意しない場合は、アカウントをキャンセルすることができます。改訂されたプライバシーポリシーが有効になるまでアカウントをキャンセルしない場合、改訂されたプライバシーポリシーの対象となります。",
            "title_14_3": "14.3 重要な変更については、状況に応じて顕著な通知を出してプライバシーポリシーの具体的な変更を示します。",
            "title_14_4": "14.4 材料変更（以下を含むがこれに限定されない）",
            "ul_4": {
                "li_1": "当社のサービスモードの重大変更。例えば、個人情報の処理目的、処理される個人情報の種類および個人情報の使用などの内容が変更されます。",
                "li_2": "所有構造および組織構造の重大変更：事業の調整、倒産または合併・買収などによる所有者の変更など",
                "li_3": "個人情報の共有、譲渡、一般公開に関するオブジェクトの変更。",
                "li_4": "お客様の権利の重大変更は個人情報処理の参加方式、および権利の行使方法と関係しています。",
                "li_5": "責任部門または連絡先情報または個人情報セキュリティの妥当性に関する苦情チャンネルの変更。",
                "li_6": "個人情報セキュリティ評価報告書に示されたリスクの高い時期。"
            },
            "para_14_4": "旧バージョンのプライバシーポリシーを確認する必要がある場合は、{supportEmail}までご連絡ください。"
        },
        "terms_15": {
            "q": "15. お問い合わせ方法",
            "para": "当該ライバシーポリシーに対してご意見、ご提案がある場合、またはこのプライバシーポリシーまたはその関連事項についてご相談される場合は、データ保護担当者{supportEmail}までご連絡ください。お客様の個人情報のデータコントローラは、このプライバシーポリシーの序文に記載されています。"
        }
    },
}

export default ja
